import { Component, EventEmitter, Output } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { AppToastService } from 'src/app/shared/toast-service/toast-service';
import { UploadService } from '../services/upload.service';
import { Observable, catchError, forkJoin, of, switchMap } from 'rxjs';

@Component({
    selector: 'app-dxf-import',
    templateUrl: './dxf-import.component.html',
    styleUrls: ['./dxf-import.component.scss'],
    standalone: false
})
export class DxfImportComponent {
  dxfFiles!: File[];
  displayError: boolean = false;
  errorMessage: string = '';
  uploadSuccessCount: number = 0;
  uploadFailedFor: string[] = [];
  uploadObservables!: Observable<any>[];

  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private spinner: NgxSpinnerService,
    public toastService: AppToastService,
    private uploadService: UploadService
  ) {}

  handleDxfImport($event: any) {
    this.displayError = false;
    const files = [...$event.target.files];
    this.dxfFiles = files.length ? files : this.dxfFiles;
    // Update the filename display span
    const display = document.getElementById('dxfFileNameDisplay');
    if (display) {
      display.textContent = files.length
        ? `${files.length} file${files.length > 1 ? 's' : ''} selected`
        : 'No files chosen';
    }
  }

  /**
   * Uploads the DXF files to the S3 bucket.
   */
  uploadDxfFiles() {
    if (!this.dxfFiles.length) {
      this.showError("Please add one or more DXF files first.");
    } else {
      this.spinner.show();

      this.uploadObservables = this.dxfFiles.map((file, index) => {
        return this.uploadService.getPresignedUrlForUploadObject(file.name, 'dxf').pipe(
          catchError(error => {
            this.uploadFailedFor.push(file.name);
            return of(''); // Return an empty observable to continue the chain
          }),
          switchMap((url: string) => {
  return this.uploadService.uploadFileToPresignedURL(file, url);
})
        );
      });

      /**
       * forkJoin will emit a single array value with the results of each observable.
       */
      forkJoin(this.uploadObservables).subscribe({
        next: results => {
          this.uploadSuccessCount = results.length - this.uploadFailedFor.length;
        },
        error: error => {
          console.error('upload failed for:', this.uploadFailedFor);
        },
        complete: () => {
          this.spinner.hide();
          if (this.uploadFailedFor.length) {
            this.showError(("Upload succeeded for " + this.uploadSuccessCount + "and failed for " + this.uploadFailedFor.length + ". Check console for the files that failed."))
          } else if (this.uploadSuccessCount === 0) {
            this.showError("Could not verify if any uploads were successful.");
          } else {
            this.closeModal();
            this.toastService.show((this.uploadSuccessCount + ' file(s) uploaded successfully'), { classname: 'bg-success text-light', delay: 4000 });
          }
        }
      });
    }
  }

  showError(message: string) {
    this.displayError = true;
    this.errorMessage = message;
  }

  closeModal() {
    this.close.emit();
  }
}